import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import Helmet from 'react-helmet'
import { TabList, Tab, Tabs, TabPanel } from 'react-tabs'
import Modal from 'react-awesome-modal'
import { Button, Alert } from 'loyal-react'

import Splash from 'App/Splash'

import client from './LikePlusClient'

import Banner from './Banner'
import Home from './Tabs/Home/Home'
import Recharge from './Tabs/Recharge/Recharge'
import RechargeAside from './Tabs/Recharge/RechargeAside'
import Help from './Tabs/Help/Help'
import HelpAside from './Tabs/Help/HelpAside'
import RequestCard from './Tabs/RequestCard/RequestCard'
import RequestAside from './Tabs/RequestCard/RequestAside'

class LikePlus extends Component {
  _isMounted = false;

  constructor (props) {
    super(props)
    this.state = {
      modalVisible: false,
      modalLoadingVisible: true,
      hasCard: false,
      page: 'home',
      initialCredit: 0,
      initialMiles: 0,
      totalPoints: 0,
      rechargePoints: 0,
      rechargeCredits: 0,
      success: false,
      address: {},
      alert: {
        show: false,
        isError: false,
        title: '',
        message: ''
      },
      transactionId: '',
      intervalObservable: null
    }
  }

  handlePage = (page) => {
    this.setState({ page })
  }

  handleInitialCredit = (initialCredit) => {
    this.setState({ initialCredit })
  }

  handleInitialMiles = (initialMiles) => {
    this.setState({ initialMiles })
  }

  handleSuccess = (success) => {
    this.setState({ success })
  }

  handleTotalPoints = (totalPoints) => {
    this.setState({ totalPoints })
  }

  handleRechargePoints = (rechargePoints) => {
    this.setState({ rechargePoints })
  }

  handleRechargeCredits = (rechargeCredits) => {
    this.setState({ rechargeCredits })
  }

  handleAddress = (address) => {
    this.setState({ address })
  }

  handleAlert = (alert) => {
    this.setState({ alert })
  }

  handleAlertClose = () => {
    this.setState({ alert: { show: false } })
  }

  handleTransactionId = (transactionId) => {
    this.setState({ transactionId })
  }

  handleIntervalObservable = (intervalObservable) => {
    this.setState({ intervalObservable })
  }

  handleOnTabSelect = (tab) => {
    console.log('tab selected: ' + tab)
    if (tab === 'first-access' || tab === 'manage-card' || tab === 'duplicate') {
      this.setState({ modalVisible: true })
      setTimeout(() => {
        const previousTab = document.querySelector(`.${this.state.page}-tab-like-plus`)
        if (previousTab) {
          previousTab.click()
        }
      }, 100)
    }
    this.setState({ page: tab })
  }

  componentDidUpdate (prev) {
    let cpf = this.props.participant.cpf.value
    if (cpf && (prev.participant.cpf.value !== cpf)) {
      let token = this.props.accessToken
      client.searchCards(this.props.participant.cpf.value, token)
        .then((hasCard) => {
          // TODO: validar retorno, caso o participant tenha cartão atualizar o state.modalVisible para true
          if (hasCard.success === true) {
            if (hasCard.hasCard) {
              this.selectRechargeTab()
              // this.setState({ modalVisible: true })
              this.setState({ hasCard: true })
            } else {
              this.setState({ hasCard: false })
            }
          }

          this.setState({ modalLoadingVisible: false })
        }).catch((hasCard) => {
          console.log('hasCard', hasCard)
          this.setState({ modalLoadingVisible: false })
        })
    }
  }

  selectRechargeTab () {
    setTimeout(() => {
      const rechargeTab = document.querySelector(`.recharge-tab-like-plus`)
      if (rechargeTab) {
        rechargeTab.click()
      }
    }, 100)
  }

  formatAddress (address) {
    let addressFormated = {
      addressType: 'Residencial',
      zipCode: address.zipCode.value,
      street: address.addressText.value,
      number: address.number.value,
      complement: address.complement.value,
      city: address.city.value,
      state: address.state.value
    }

    return addressFormated
  }

  async getCardTaxes (token) {
    let retorno = await client.searchTaxes(token)
    return retorno
  }

  async getPointsConverted (points, token) {
    let retorno = await client.pointsToCash(points, token)
    return retorno
  }

  render () {
    return (
      <Fragment>
        <Helmet>
          <title>{`Like Plus - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <Modal width='580' height='400' effect='fadeInUp' visible={this.state.modalVisible}>
          <div className='bg-white radius'>
            <div className='col-12 border-color-ui-3 bg-white border px-3 py-4'>
              <h2>Você será redirecionado</h2>
            </div>
            <div className='d-flex px-3 py-3 flex-column align-items-center justify-content-center'>
              <div className='col-12 d-flex justify-content-center'>
                <div className='icon icon_redirect_likeplus' />
              </div>
              <p className='mt-2 txt-center'>
                O serviço que você escolheu só está disponível no site do parceiro.
                Clique em <strong>Vamos lá</strong> para ser redirecionado ou <strong>Cancelar</strong> para voltar a página do Cartão Like Mais.
              </p>
            </div>
            <div className='d-flex px-3 pb-3 border-bottom-brand-1'>
              <Button className='mr-md-1 mb-2 mb-md-0 col-6' onClick={() => this.setState({ modalVisible: false })} text='Cancelar' />
              <a className='mb-2 ml-1 m-md-0 btn btn-featured btn-icon txt-button txt-font-body col-6 p-0 d-flex align-items-center justify-content-center' role='button'>Vamos lá</a>
            </div>
          </div>
        </Modal>
        <Modal width='580' height='400' effect='fadeInUp' visible={this.state.modalLoadingVisible}>
          <div className='bg-white radius'>
            <Splash text='Checando seu cartão' />
          </div>
        </Modal>
        {
          this.state.page === 'home' && <Banner />
        }
        {this.state.alert.show &&
          (<div className='mx-md-5 mx-1 mt-5'>
            <Alert
              isError={this.state.alert.isError}
              title={this.state.alert.title}
              description={this.state.alert.message}
              onClose={this.handleAlertClose}
            />
          </div>)}
        <div className='py-sm-2 pt-md-3 d-flex justify-content-center flex-column flex-md-row'>
          <div className={`${this.state.page === 'home' ? 'col-12 px-1 px-md-1 d-flex flex-column justify-content-center align-items-center' : 'col-12 col-md-7 p-0'} mr-1 `}>
            {this.state.page !== 'home' && (
              <div className='col-12 p-0'>
                <div className='bg-secondary'>
                  <h2>Cartão Like Mais</h2>
                </div>
              </div>
            )}
            <div className={`${this.state.page === 'home' ? 'col-12 col-md-11' : 'col-12'} p-0 border-color-ui-3 bg-white radius`}>
              <Tabs className='col-12 product-tabs border radius-top border-color-ui-3 px-0'>
                <div className='col-12 p-0 border-color-ui-3 bg-white border-bottom'>
                  <TabList className={`overflow overflow-md-hidden tabs-item tab-like-plus pt-3 pb-3 mx-0 d-md-flex justify-content-md-start ${this.state.page !== 'home' ? 'col-12' : 'col-12'}`}>
                    <Tab
                      onClick={() => this.handleOnTabSelect('home')}
                      className='home-tab-like-plus mx-2 mx-md-1 item-button-like pos-relative d-inline-block px-0 txt-circular-black txt-uppercase txt-body'>
                      Início
                    </Tab>
                    {(this.state.hasCard === false) && (<Tab
                      onClick={() => this.handleOnTabSelect('card')}
                      className='card-tab-like-plus mx-2 mx-md-1 item-button-like pos-relative d-inline-block px-0 txt-circular-black txt-uppercase txt-body'>
                      Solicite seu cartão
                    </Tab>)}
                    <Tab
                      onClick={() => this.handleOnTabSelect('recharge')}
                      className='recharge-tab-like-plus mx-2 mx-md-1 item-button-like pos-relative d-inline-block px-0 txt-circular-black txt-uppercase txt-body'>
                      Faça uma recarga
                    </Tab>
                    <Tab
                      onClick={() => this.handleOnTabSelect('first-access')}
                      className='first-access-tab-like-plus mx-2 mx-md-1 item-button-like pos-relative d-inline-block px-0 txt-circular-black txt-uppercase txt-body'>
                      Primeiro acesso
                    </Tab>
                    <Tab
                      onClick={() => this.handleOnTabSelect('manage-card')}
                      className='manage-card-tab-like-plus mx-2 mx-md-1 item-button-like pos-relative d-inline-block px-0 txt-circular-black txt-uppercase txt-body'>
                      Gerencie seu cartão
                    </Tab>
                    <Tab
                      onClick={() => this.handleOnTabSelect('duplicate')}
                      className='duplicate-tab-like-plus mx-2 mx-md-1 item-button-like pos-relative d-inline-block px-0 txt-circular-black txt-uppercase txt-body'>
                      2ª via
                    </Tab>
                    <Tab
                      onClick={() => this.setState({ page: 'help' })}
                      className='help-tab-like-plus mx-2 mx-md-1 item-button-like pos-relative d-inline-block px-0 txt-circular-black txt-uppercase txt-body'>
                      Ajuda
                    </Tab>
                  </TabList>
                </div>

                <TabPanel className='mb-5 mb-md-0'>
                  <Home />
                </TabPanel>

                {(this.state.hasCard === false) && (<TabPanel>
                  <RequestCard
                    success={this.state.success}
                    initialCredit={this.state.initialCredit}
                    totalPoints={this.state.totalPoints}
                    initialMiles={this.state.initialMiles}
                    address={this.formatAddress(this.props.participant.address)}
                    handleInitialCredit={this.handleInitialCredit}
                    handleInitialMiles={this.handleInitialMiles}
                    handleAddress={this.handleAddress}
                    handlePointsConversion={this.getPointsConverted}
                    accessToken={this.props.accessToken}
                    balance={this.props.balance}
                    transactionId={this.state.transactionId} />
                </TabPanel>)}

                <TabPanel>
                  <Recharge
                    success={this.state.success}
                    rechargePoints={this.state.rechargePoints}
                    rechargeCredits={this.state.rechargeCredits}
                    handleRechargePoints={this.handleRechargePoints}
                    handleRechargeCredits={this.handleRechargeCredits}
                    handlePointsConversion={this.getPointsConverted}
                    accessToken={this.props.accessToken}
                    balance={this.props.balance}
                    transactionId={this.state.transactionId}
                    intervalObservable={this.state.intervalObservable}
                    handleIntervalObservable={this.handleIntervalObservable} />
                </TabPanel>

                <TabPanel>
                  <div className='p-3' />
                </TabPanel>

                <TabPanel>
                  <div className='p-3' />
                </TabPanel>

                <TabPanel>
                  <div className='p-3' />
                </TabPanel>

                <TabPanel>
                  <Help />
                </TabPanel>
              </Tabs>
            </div>
          </div>
          {
            this.state.page === 'help' &&
            <div className='col-12 mt-2 mt-md-0 mb-5 mb-md-5 col-md-4 p-0'>
              <HelpAside />
            </div>
          }
          {
            this.state.page === 'recharge' &&
            <div className='col-12 mt-2 mt-md-0 mb-5 mb-md-5 col-md-4 p-0'>
              <RechargeAside
                success={this.state.success}
                participant={this.props.participant}
                address={this.state.address}
                rechargePoints={this.state.rechargePoints}
                rechargeCredits={this.state.rechargeCredits}
                handleSuccess={this.handleSuccess}
                accessToken={this.props.accessToken}
                balance={this.props.balance}
                handleAlert={this.handleAlert}
                handleTransactionId={this.handleTransactionId} />
            </div>
          }
          {
            this.state.page === 'card' &&
            <div className='col-12 mt-2 mt-md-0 mb-5 mb-md-5 col-md-4 p-0'>
              <RequestAside
                success={this.state.success}
                initialCredit={this.state.initialCredit}
                initialMiles={this.state.initialMiles}
                participant={this.props.participant}
                address={this.state.address}
                handleSuccess={this.handleSuccess}
                handleTotalPoints={this.handleTotalPoints}
                handleCardTaxes={this.getCardTaxes}
                accessToken={this.props.accessToken}
                balance={this.props.balance}
                handleAlert={this.handleAlert}
                handleTransactionId={this.handleTransactionId} />
            </div>
          }
          <div />
        </div>
      </Fragment>
    )
  }
}

LikePlus.propTypes = {
  participant: PropTypes.shape({
    name: PropTypes.object,
    cpf: PropTypes.object,
    address: PropTypes.object
  }).isRequired,
  accessToken: PropTypes.string,
  balance: PropTypes.object
}

const mapStateToProps = ({
  participant,
  oidc: {
    user: {
      access_token: accessToken
    }
  },
  balance
}) => ({ participant, accessToken, balance })

export default connect(
  mapStateToProps,
  null
)(LikePlus)



// WEBPACK FOOTER //
// ./src/features/LikePlus/Container.js